export const AppConfig = {
  API_URL: "https://api-nefroapp.caladrius.com.br",
  AUTH0: {
    CLIENT_ID: "vc54W3kl1iE6UvM8iDjcP7oouMsZj4RE",
    AUDIENCE: "https://caladrius.us.auth0.com/api/v2/",
    DOMAIN: "caladrius.us.auth0.com",
  },
};
